import "./Diferencial.css";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

 function Diferencial() {
  const diferenciais = [
    {
      icon: "visibility",
      title: "Consulta de imersão",
      text: "Cada atendimento é um mergulho completo no histórico do paciente, sem pressa e sem protocolo genérico.",
    },
    {
      icon: "lightbulb",
      title: "Clareza técnica",
      text: "O paciente sai da consulta entendendo exatamente o que tem, o que é possível fazer e o que a ciência sustenta.",
    },
    {
      icon: "history_toggle_off",
      title: "Acompanhamento contínuo",
      text: "O cuidado não termina no fechamento do ponto cirúrgico.",
    },
    {
      icon: "favorite",
      title: "Atendimento VIP e humanizado",
      text: "Casos complexos tratados com respeito à intimidade e ao sofrimento físico e emocional.",
    },
    {
      icon: "verified",
      title: "Alta especialização",
      text: "Referência regional para casos que outros profissionais não atendem.",
    },
  ];

  return (
    <section className="diferencial-section">
      <div className="container">
        <h2 className="diferencial-title text-center scroll-reveal-opacity">
          Um cuidado diferente do convencional
        </h2>

        <div className="row text-center justify-content-center">
          {diferenciais.map((item, index) => (
            <div
              key={index}
              className="col-12 col-sm-6 col-lg-4 difer-item scroll-reveal-opacity"
            >
              <span className="material-symbols-outlined difer-icon">
                {item.icon}
              </span>

              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Diferencial;